module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_sns_03-7f5cde9a51dfa5aaeec1b4b440003282.jpg";